import React from 'react';
import MobileBottomNav from './MobileBottomNav';
import DesktopSidebar from './DesktopSidebar';
import useMediaQuery from '../../hooks/useMediaQuery';

/**
 * NavigationWrapper - Responsive navigation that adapts to screen size
 * - Mobile/Tablet (< 1024px): Bottom tab bar
 * - Desktop (>= 1024px): Left sidebar
 */
export default function NavigationWrapper() {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <>
      {isDesktop ? <DesktopSidebar /> : <MobileBottomNav />}
    </>
  );
}
